const SoFormStepPrice = {
  nameForData: 'SO_FORM_STEP_PRICE',
};

export default SoFormStepPrice;
